import { FC } from 'react'
import { CustomSelect, IOption } from '../../../../../../components/Input/CustomSelect'
import { TableFilter, TableFilters } from '../../../../../../components/Table/TableFilters'
import { ProtocoloLinha } from '../../../core/_models'

type Props = {
  outrasVersoes: ProtocoloLinha[]
  /** Versão escolhida; `undefined` = a vigente (padrão). */
  com?: number
  onChange: (com?: number) => void
}

/** Barra do card: com qual versão comparar (padrão: a vigente). */
export const ComparacaoProtocoloHeader: FC<Props> = ({ outrasVersoes, com, onChange }) => {
  const opcoes: IOption[] = [
    { label: 'Versão vigente', value: null },
    ...outrasVersoes.map((versao) => ({ label: `Versão ${versao.versao}`, value: versao.id })),
  ]

  return (
    <div className='card-header border-0 pt-6'>
      <TableFilters>
        <TableFilter label='Comparar com' htmlFor='comparar-com' wide>
          <CustomSelect
            inputId='comparar-com'
            options={opcoes}
            value={opcoes.find((opcao) => opcao.value === (com ?? null))}
            onChange={(opcao: IOption | null) =>
              onChange(opcao?.value ? Number(opcao.value) : undefined)
            }
            isClearable={false}
          />
        </TableFilter>
      </TableFilters>
    </div>
  )
}
